import axios from 'axios';
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import MediumHeading from '../UI/MediumHeading';
import './style.css'

const Blogs = () => {

    const [profile, setprofile] = useState({feed:{
         title: "",
       url:"",
       image:"",
       link:""
      },
      items: [],
    })

const getMediumBlogs=async()=>{
         const mediumURL =
         "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@rashidrizvi";
         
         const response=await axios.get(mediumURL)
         setprofile(response.data)
       }
       const ToText=(node)=> {
        let tag = document.createElement("div");
        tag.innerHTML = node;
        node = tag.innerText;
        return node;
    }
       
       useEffect(()=>{
           getMediumBlogs()
       },[])

  return (
    <div style={{marginTop:"100px"}}>
          <MediumHeading text={"Articles I have written"} />
          <div className="flexCol flexRow justify-se wrap" style={{color:"#333333",paddingTop:"60px"}}>
              {profile.items.map((item)=>( <div class="blog_card blog_card_mobile scaleUp">
  
      <img src={item.thumbnail} alt="" class="blog_card_image"/>
 
    <div class="blog_card_body">     
      <h4>{item.title}</h4>      
      <p>{`${ToText(item.description.substring(0,250).substring(0, Math.min(item.description.substring(0,250).length, item.description.substring(0,250).lastIndexOf(" "))))}`}</p>
      <div className="flexRow wrap">
      {item.categories.map((category)=>(<span class="blog_tag blog_tag-blue">{category}</span>))}
        </div>
      <p >
      <a className="font-18 bold-600 primaryColor ls-1 text-center mtb-10" href={item.link}>Read on Medium</a>
    </p>
    </div>
    <div class="blog_card_footer">
      <div class="blog_user">
        <img src={profile.feed.image} alt="user__image" class="blog_user_image"/>
        <div class="blog_user_info">
          <h5>{item.author}</h5>
          <small>{moment(item.pubDate).format("MMM DD, YYYY")}</small>
        </div>
      </div>
    </div>
  </div>))}
          </div>

    </div>
  )
}

export default Blogs